import { render, staticRenderFns } from "./EnrolmentSuccess.vue?vue&type=template&id=3b46374a"
import script from "./EnrolmentSuccess.vue?vue&type=script&lang=ts"
export * from "./EnrolmentSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports